// Query params
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp'
export const PARAM_IS_HEADER_MINI_APP_EXPAND = 'isHeaderMiniAppExpand'
export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_IS_TBPN_SELECT_VEHICLE_TYPE = 'isTBPNSelectVehicleType' // bật/tắt chọn loại phương tiện cho thông báo phạt nguội
export const PARAM_IS_TBPN_SELECT_VEHICLE_TYPE_WITH_ELECTRIC_MOTOBIKE = 'isTBPNSelectVehicleTypeWithElectricMotobike' // bật/tắt tuỳ chọn xe điện
export const PARAM_IS_SELECT_VEHICLE_TYPE_USE_ICON = 'isSelectVehicleTypeUseIcon' // dùng giao diện icon thay vì select
export const PARAM_APIKEY = 'apikey' // apikey cố định mặc định cho app chứ ko phải để chuyển link
export const PARAM_PAYMENT_METHOD = 'paymentMethod' // phương thức thanh toán cố định mặc định 1 thanh toán
export const PARAM_HIDE_PAYMENT_METHOD = 'hidePaymentMethod' // ẩn mục chọn phương thức thanh toán
export const PARAM_PHONE_NUMBER = 'phoneNumber'
export const PARAM_PARTNER_NAME = 'partnerName'
export const PARAM_BACK_TO_HOME_MINI_APP_URL = 'backToHomeMiniAppUrl'

export const PARAM_REFER_USER_ID = 'referUserId' // id người giới thiệu
export const PARAM_REFER_STATION_ID = 'referStationId' // id trạm giới thiệu
export const PARAM_IS_DISPLAY_REFER_USER_CODE = 'isDisplayReferUserCode' // ẩn/hiện ô nhập mã giới thiệu (mặc định hiện)
export const PARAM_REFER_USER_CODE = 'referUserCode' // mã giới thiệu (truyền qua URL, auto fill & submit)
export const PARAM_IS_DISPLAY_PROMOTION_CODE = 'isDisplayPromotionCode' // ẩn/hiện ô nhập mã giảm giá (mặc định hiện)
export const PARAM_APP_THEME_NAME = 'appThemeName' // Giống vs REACT_APP_THEME_NAME sẽ hiển thị theme trên link build cũ
export const PARAM_SHOW_PHONE_INPUT = 'showPhoneInput' // Chỉ check ẩn input số điện thoại khi có số điện thoại sdkPhoneNumber (mặc định hiện)

// PostMessage keys
export const MESSAGE_BACK_TO_HOME_MINI_APP = 'BackToHomeMiniApp'

// Thông tin từ sdk đối tác
export const PARAM_SDK_PHONE_NUMBER = 'sdkPhoneNumber' 
export const PARAM_SDK_FULL_NAME = 'sdkFullName'
export const PARAM_SDK_USERNAME = 'sdkUsername'
export const PARAM_SDK_TOKEN = 'sdkToken'
